module.exports = __webpack_public_path__ + "img/8.dac77ccd.png";